// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import { SvgIcon, Text, Flex } from 'Components/Base';
import useCompatibleDisplay from 'Util/Hooks/useCompatibleDisplay';
import { useOffset } from 'Context/LayoutContext/OffsetProvider';

import { CLEAR_PLUS_TABS } from '../../Contexts/ClearPlusByOnDemandProvider';

const SPACING_PADDING = 12;

function FlexWrapper({ topOffset, ...restProps }) {
  return (
    <Flex
      top={0}
      zIndex={1}
      paddingLeft={4}
      paddingRight={2}
      paddingTop={topOffset > 0 ? topOffset + SPACING_PADDING : 0}
      width={'100%'}
      alignItems={'center'}
      justifyContent={'space-between'}
      backgroundColor={'white'}
      style={{ boxShadow: '0 -2px 4px rgba(0, 0, 0, 0.1)', borderBottom: '1px solid #D8D8D8' }}
      {...restProps}
    />
  );
}

function StyledTab({ topOffset, title, isActive, isMobile, icon, iconSize, ...props }) {
  const color = isActive ? 'clear.clearDark' : 'clear.clearGrayDark';
  return (
    <Tab
      label={
        <Flex alignItems={'center'}>
          <SvgIcon icon={icon} mr={2} width={iconSize} height={iconSize} color={color} />
          <Text textStyle={isMobile ? 'body1' : 'heading5'} color={color} fontWeight={'bold'}>
            {title}
          </Text>
        </Flex>
      }
      style={{
        marginRight: 8,
        paddingTop: topOffset > 0 ? 12 : 24,
        paddingBottom: topOffset > 0 ? 12 : 16,
        paddingX: 16,
        textTransform: 'capitalize',
      }}
      {...props}
    />
  );
}

function ClearPlusHeader({ onCloseDrawer, activeTab, setActiveTab, ...restProps }) {
  const { topOffset } = useOffset();
  const { isMobile } = useCompatibleDisplay();

  return (
    <FlexWrapper topOffset={topOffset} {...restProps}>
      <Tabs value={activeTab} onChange={(_event, value) => setActiveTab(value)}>
        <StyledTab
          title={'CLEAR'}
          value={CLEAR_PLUS_TABS.FAQ}
          isActive={activeTab === CLEAR_PLUS_TABS.FAQ}
          isMobile={isMobile}
          icon={SvgIcon.ICON_LIST.CLEAR_HEADER_ICON}
          iconSize={isMobile ? 28 : 34}
          topOffset={topOffset}
        />
        <StyledTab
          title={'Online solution'}
          value={CLEAR_PLUS_TABS.ONLINE_SOLUTION}
          isActive={activeTab === CLEAR_PLUS_TABS.ONLINE_SOLUTION}
          isMobile={isMobile}
          icon={SvgIcon.ICON_LIST.ONLINE_SOLUTION_ICON}
          iconSize={isMobile ? 24 : 30}
          topOffset={topOffset}
        />
      </Tabs>
      <IconButton onClick={onCloseDrawer}>
        <SvgIcon
          icon={SvgIcon.ICON_LIST.CLOSE}
          size={isMobile ? 24 : 26}
          color={'textColor.secondary'}
        />
      </IconButton>
    </FlexWrapper>
  );
}

ClearPlusHeader.propTypes = {
  onCloseDrawer: PropTypes.func,
  activeTab: PropTypes.string,
  setActiveTab: PropTypes.func,
};

FlexWrapper.propTypes = { topOffset: PropTypes.number };

StyledTab.propTypes = {
  title: PropTypes.string,
  isActive: PropTypes.bool,
  isMobile: PropTypes.bool,
  icon: PropTypes.func,
  iconSize: PropTypes.number,
  topOffset: PropTypes.number,
};

export default ClearPlusHeader;
